// RedeemedHistory.tsx
import { fetchPointsMallRules } from '@/api/account';
import Dialog from '@/components/Dialog';
import LoadingCircular from '@/components/LoadingCircular';
import Popup from '@/components/Popup';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { font } from '@/theme/zeelool.theme';
import logger from '@/utils/client-logger';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import React, { useEffect, useState } from 'react';
interface ITipsDialogProps {
  show: boolean;
  onClose: () => void;
}

const TipsDialog: React.FC<ITipsDialogProps> = ({ show, onClose }) => {
  const t = useTranslations('account.pointsMall.tipsDialog');
  const [text, setText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    if (show && !text) {
      fetchText();
    }
  }, [show]);

  const fetchText = async () => {
    setLoading(true);
    try {
      const res = await fetchPointsMallRules();
      setText(res.data.point_rule_description?.pointsContent || '');
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    if (loading) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            minHeight: '200px',
          }}
        >
          <LoadingCircular />
        </Box>
      );
    }
    return (
      <Box
        className="redeemable-tips"
        dangerouslySetInnerHTML={{ __html: text }}
        sx={{
          fontSize: '14px',
          fontFamily: font.ir,
          '& p': {
            mb: 1,
            lineHeight: '22px',
            fontSize: '14px',
            fontFamily: font.ir,
          },
          '& strong': {
            fontFamily: font.ib,
          },
          '& h1, & h2, & h3, & h4, & h5, & h6': {
            fontSize: '18px',
            fontFamily: font.ib,
          },
        }}
      />
    );
  };
  return (
    <>
      <WebOnly>
        <Dialog.Info
          open={show}
          maxWidth="lg"
          onClose={onClose}
          PaperProps={{ style: { maxHeight: '80vh', minHeight: '460px' } }}
          title={t('title')}
          sx={{ '& .MuiDialogContent-root': { height: '85vh' } }}
        >
          {renderContent()}
        </Dialog.Info>
      </WebOnly>
      <WapOnly>
        <Popup open={show} onClose={onClose} position="bottom" title={t('title')} height="76vh">
          {renderContent()}
        </Popup>
      </WapOnly>
    </>
  );
};

export default TipsDialog;
